//@ts-nocheck
import { TransactionTypeFilter } from "@/store/modules/transactions"
import i18n from "@/i18n";

export default {
	methods: {
		onChangeFrom(e: Event) {
			this.currentFilter.from = e.target.value;
		},
		onChangeTo(e: Event) {
			this.currentFilter.to = e.target.value;
		},
	},
	computed: {
		currentFilter: {
			get: function() {
				return this.$store.state.transactions.transactionsValueFilter;
			},
			set: function(newValue) {
				this.$store.state.transactions.transactionsValueFilter = newValue;
			},
		},
	},
	render: function(h) {
		return (
			<div class="transactions-value-picker">
				<div class="text-center">
					<input
						placeholder={i18n.t("from") + ":"}
						class="w-100 mt-2 form-control"
						type="number"
						value={this.currentFilter.from}
						onChange={this.onChangeFrom} />
					<input
						placeholder={i18n.t("to") + ":"}
						class="w-100 mt-2 form-control"
						type="number"
						value={this.currentFilter.to}
						onChange={this.onChangeTo} />
				</div>
			</div>
		);
	},
};
